export const scale = (
    canvas: HTMLCanvasElement,
    context: CanvasRenderingContext2D,
    maxX: number,
    minX: number,
    maxY: number,
    minY: number
) => {
    const width = canvas.width;
    const height = canvas.height;

    // get a scale to best fit the canvas
    const scale = Math.min(width / (maxX - minX), height / (maxY - minY)) / 1.1;

    // set the transform so that you can draw to the canvas
    context.setTransform(scale, 0, 0, scale, 0, canvas.height);
    context.scale(1, -1);
};
